import React from 'react';

import {
  faChevronRight,
  faClockRotateLeft,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NeoLeoAvatar from '../../assets/img/neo-leo.png';
import AnalyticsService from '../../services/AnalyticsService';
import { AnalyticsEventEnum } from '../../types';
import { cn } from '../../utils/classUtils';

interface NeoLeoHeaderProps {
  setShowHistory(show: boolean): void;
  isShowingHistory: boolean;
  hideHistory?: boolean;
  startNewSession(): void;
  onClose: () => void;
  isMobile?: boolean;
}

const NeoLeoHeader: React.FC<NeoLeoHeaderProps> = ({
  setShowHistory,
  isShowingHistory,
  hideHistory = false,
  startNewSession,
  onClose,
  isMobile,
}) => {
  const showHistoryButton = !hideHistory && !isShowingHistory;
  return (
    <div
      className='flex flex-row items-center justify-between py-3 px-4 bg-reskin-primary-navy font-inter border-b border-[#2D355C]'
      style={{
        boxShadow: '0px 4px 24px 0px rgba(2, 7, 32, 0.47)',
      }}
    >
      <div className='flex flex-row items-center'>
        <img
          className='w-6 h-6 mr-2 cursor-pointer'
          src={NeoLeoAvatar}
          onClick={startNewSession}
          alt='neo-leo-avatar'
        />
        <p className='font-poppins font-medium text-white text-sm leading-5'>
          Leo
        </p>
      </div>
      <div className='flex flex-row space-x-6 items-center relative'>
        {showHistoryButton && (
          <button
            type='button'
            className='appearance-none'
            onClick={() => {
              setShowHistory(true);
              AnalyticsService.instance().logEvent(
                AnalyticsEventEnum.LEO_MESSAGE_HISTORY_CLICK,
              );
            }}
          >
            <FontAwesomeIcon
              icon={faClockRotateLeft}
              className='text-base text-white hover:text-white'
              data-testid='neo-leo-history-button'
            />
          </button>
        )}
        <button
          type='button'
          className='appearance-none'
          onClick={onClose}
          data-testid='close-leo-chat'
        >
          <FontAwesomeIcon
            icon={isMobile ? faXmark : faChevronRight}
            className={cn(
              'text-base text-white hover:text-white',
              isMobile ? 'text-xl' : 'text-base',
            )}
          />
        </button>
      </div>
    </div>
  );
};

export default NeoLeoHeader;
